import { DownloadIcon } from "@chakra-ui/icons";
import { Box, ButtonGroup } from "@chakra-ui/react";
import React from "react";
import { useTranslation } from "react-i18next";
import { MdChevronRight } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import CustomButton from "../../../components/Common/CustomButton";
import SingleFileUpload from "../../../components/Common/CustomUpload";

interface Props {
  handleDownloadExcel: () => void;
  handleUploadImage?: (url: string, name?: string) => void;
}

const Filter: React.FC<Props> = ({
  handleDownloadExcel,
  handleUploadImage,
}) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  return (
    <React.Fragment>
      <Box display="flex" flexDirection="column">
        <ButtonGroup justifyContent={"flex-end"}>
          <CustomButton
            handleClick={() => {
              handleDownloadExcel();
            }}
            title={t("order.list.excelDownload")}
            variant="light"
            sx={{ marginRight: "20px" }}
            leftIcon={<DownloadIcon />}
            isLeftIcon
          />
          <SingleFileUpload
            file={""}
            title={""}
            iaExcelUpload
            isRequiredFalse
            handleUploadImage={(url: string, name?: string) => {
              if (handleUploadImage) {
                handleUploadImage(url, name);
              }
            }}
          />
          <CustomButton
            handleClick={() => {
              navigate("/admin/product/excel-list");
            }}
            title={t("order.list.excelList")}
            variant="light"
            sx={{ marginRight: "20px" }}
            rightIcon={<MdChevronRight />}
            isRightIcon
          />
        </ButtonGroup>
      </Box>
    </React.Fragment>
  );
};

export default Filter;
